import {
  CheckboxQuestionConfig,
  CheckboxResponseState,
  FeatureName,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { useController } from 'react-hook-form';
import { StyleSheet } from 'react-native';
import { Colors } from '../../../../../themes/colors';
import { useFormContext } from '../../../../forms';
import { ControlledCheckboxItems } from '../../../../forms/controlledCheckboxItems';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const CheckboxQuestionExecutionFormOld: RoutineQuestionExecutionForm<
  CheckboxQuestionConfig,
  CheckboxResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    CheckboxQuestionConfig,
    CheckboxResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const defaultValue = props?.isIssueEditRoutine
    ? props?.currentState?.state?.responses?.[props.responseIndex]?.options ??
      []
    : [];
  const { control } = useFormContext();
  const { field } = useController({
    control: control,
    name: `${fieldPrefix}.options`,
    defaultValue: defaultValue,
  });

  return (
    <ControlledCheckboxItems
      control={control}
      name={field.name}
      options={props.config.options.map((option) => {
        return {
          value: option,
        };
      })}
      position="leading"
      style={styles.container}
      labelStyle={styles.label}
      mode="android"
      color={Colors.blue}
    />
  );
};

// TODO: Crop Circle Redesign | Remove to CheckboxQuestionExecutionFormBase after feature is fully rolled out
const CheckboxQuestionExecutionFormBase: RoutineQuestionExecutionForm<
  CheckboxQuestionConfig,
  CheckboxResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    CheckboxQuestionConfig,
    CheckboxResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const defaultValue = props?.isIssueEditRoutine
    ? props?.currentState?.state?.responses?.[props.responseIndex]?.options ??
      []
    : [];
  const { control } = useFormContext();
  const { field } = useController({
    control: control,
    name: `${fieldPrefix}.options`,
    defaultValue: defaultValue,
  });

  return (
    <ControlledCheckboxItems
      control={control}
      name={field.name}
      options={props.config.options.map((option) => {
        return {
          value: option,
        };
      })}
      position="leading"
      style={styles.container}
      labelStyle={styles.label}
      mode="android"
      color={Colors.blue}
      useCropCircle
    />
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const CheckboxQuestionExecutionForm: RoutineQuestionExecutionForm<
  CheckboxQuestionConfig,
  CheckboxResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    CheckboxQuestionConfig,
    CheckboxResponseState
  >
) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <CheckboxQuestionExecutionFormOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to CheckboxQuestionExecutionFormBase after feature is fully rolled out
  return <CheckboxQuestionExecutionFormBase {...props} />;
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 0,
  },
  label: {
    fontSize: 16,
    lineHeight: 19,
    color: Colors.black,
    fontWeight: '400',
    textAlign: 'left',
  },
});
